import axios from "@/utils/axios.js";
import { ElMessage } from "element-plus";
import _exports from '@/utils/export';

export async function getData(data, url, tips) {
	let res = await axios({
		url,
		method: "post",
		data,
	});
	if (res.data.subCode === 10002) {
		if (tips) {
			ElMessage.success(`${tips}成功！`)
		}
		return res.data.data
	} else if (res.data.subCode !== 10002) {
		ElMessage.error(res.data.subMessage)
		return Promise.reject(res.data.subMessage)
	}
}
export async function exportData(data, url, type) {
	// let myNotify = Notification({
	// 	message: '正在导出，请稍后！',
	// 	duration: 0
	// })
	let res = await axios({
		url,
		method: "post",
		data,
		responseType: 'blob'
	});
	// myNotify.close()
	if (res.headers['content-type'] === 'application/json') {
		_exports.fileExportResponseError(res.data)
	} else {
		ElMessage.success(`导出成功！`)
		_exports.downFile(
			res.data,
			type,
			res.headers['content-disposition'] && decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8")
		)
	}
}
